<div class="snackbar-window" [ngClass]="getVariantClass()">
  <div class="snackbar-icon"><img [src]="getVariantIcon()" alt="snackbar icon" /></div>
  <div class="snackbar-content">
    <div class="snackbar-header">{{ data.header }}</div>
    <div class="snackbar-message">{{ data.message }}</div>
  </div>
</div>
